import { render, staticRenderFns } from "./insideOrder.vue?vue&type=template&id=65883b86&scoped=true&"
import script from "./insideOrder.vue?vue&type=script&lang=js&"
export * from "./insideOrder.vue?vue&type=script&lang=js&"
import style0 from "./insideOrder.vue?vue&type=style&index=0&id=65883b86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65883b86",
  null
  
)

component.options.__file = "insideOrder.vue"
export default component.exports